export default "__VITE_ASSET__BiM$msRJ__"